import '.f4{display:inline-flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.am{height:40px;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.g3{width:360px;}.ssr-plugin'
import '.gx{transition-timing-function:ease-in-out;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import '.bh{position:fixed;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.m{flex:1;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import '.x{border:none;}.ssr-plugin'
import '.a8{background:transparent;}.ssr-plugin'
import '.cg{font-size:14px;}.ssr-plugin'
import '.jw{font-weight:400;}.ssr-plugin'
import '.o{height:100%;}.ssr-plugin'
import '.gq{padding:0 8px;}.ssr-plugin'
import '.jx{margin:0 4px;}.ssr-plugin'
import '.cb{width:1px;}.ssr-plugin'
import '.aw{height:16px;}.ssr-plugin'
import { LinkNode } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import { $getSelection, $isRangeSelection, $setSelection } from 'lexical'
import { useEffect, useState } from 'react'
import { colors } from '../../../tokens/colors.js'
import { shadows } from '../../../utils/shadows.js'
import { radius } from '../../../utils/radius.js'
import { IconButton } from '../../IconButton/index.js'
import { useToast } from '../../Toast/index.js'
import { styled } from 'inlines'

function FloatingLinkPlugin() {
  const [editor] = useLexicalComposerContext()
  const [open, setOpen] = useState(false)
  const [prevValue, setPrevValue] = useState<string>()
  const [value, setValue] = useState<string>()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const toast = useToast()

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setOpen(false)
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [value, prevValue])

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection()

          if (!$isRangeSelection(selection)) return

          const root = editor.getRootElement()
          const anchor = selection.anchor.getNode()
          const anchorParent = anchor.getParent()
          const native = window.getSelection()

          const node =
            anchor instanceof LinkNode
              ? anchor
              : anchorParent instanceof LinkNode
                ? anchorParent
                : null

          if (node && root.contains(native.anchorNode)) {
            const rect = native.focusNode.parentElement.getBoundingClientRect()
            const x = rect.left
            const y = rect.top

            setPosition({ x, y: y + rect.height + 8 })
            setValue(node.__url)
            setPrevValue(node.__url)
            setOpen(true)

            return
          }

          setOpen(false)
          setValue('')
          setPrevValue('')
        })
      }),
    )
  }, [editor, value])

  return (
    <>
      {open && (
        <div className="f4 d am fj g3 gx bj bh"
          style={{
            background: colors.neutralInverted100,
            border: `1px solid  ${colors.neutral20Adjusted}`,
            boxShadow: shadows.popoverSmall,
            borderRadius: radius[16],
            left: position.x,
            top: position.y,
          }}
        >
          <div className="n f4 c d a3 h"
          >
            <input className="m fk x a8 cg jw h o gq"
              // autoFocus={!value?.length}
              value={value}
              onChange={(e) => {
                setValue(e.target.value)
              }}
              placeholder="Add link"
              style={{
                color: colors.neutral80,
              }}
            />
            {value === prevValue ? (
              <>
                {value && (
                  <>
                    <IconButton
                      size="small"
                      icon="arrow-out"
                      tooltip="Open in new tab"
                      onClick={() => {
                        const val = value.includes('http')
                          ? value
                          : 'https://' + value

                        window.open(val, '_blank', 'noopener,noreferrer')
                        editor.update(() => {
                          $setSelection(null)
                        })
                        setOpen(false)
                      }}
                    />
                    <IconButton
                      size="small"
                      icon="copy"
                      tooltip="Copy link"
                      onClick={() => {
                        navigator.clipboard.writeText(value)
                        toast('Link copied', { icon: 'copy' })
                        editor.update(() => {
                          $setSelection(null)
                        })
                        setOpen(false)
                      }}
                    />
                  </>
                )}
                <div className="jx cb aw"
                  style={{
                    background: colors.neutral20Adjusted,
                  }}
                />
                <IconButton
                  size="small"
                  icon="link-off"
                  tooltip="Remove link"
                  onClick={() => {
                    editor.update(() => {
                      const selection = $getSelection()
                      if (!$isRangeSelection(selection)) return

                      const nodes = selection.extract()
                      nodes.forEach((node) => {
                        const parent = node.getParent()
                        if (parent instanceof LinkNode) {
                          const children = parent.getChildren()
                          for (let i = 0; i < children.length; i++) {
                            parent.insertBefore(children[i])
                          }
                          parent.remove()
                        }
                      })
                    })
                  }}
                />
              </>
            ) : (
              <>
                <IconButton
                  size="small"
                  icon="checkmark-normal"
                  tooltip="Save changes"
                  keyHint="Enter"
                  onClick={() => {
                    editor.update(
                      () => {
                        const selection = $getSelection()
                        if (!$isRangeSelection(selection)) return
                        const nodes = selection.extract()
                        nodes.forEach((node) => {
                          const parent = node.getParent()
                          if (parent instanceof LinkNode) {
                            parent.setURL(value)
                          }
                        })
                        nodes[nodes.length - 1].selectEnd()
                      },
                      {
                        onUpdate: () => {
                          setOpen(false)
                        },
                      },
                    )
                  }}
                />
                <IconButton
                  size="small"
                  icon="close"
                  tooltip="Discard changes"
                  keyHint="Esc"
                  keyHintVisualOnly
                  onClick={() => {
                    setOpen(false)
                  }}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export { FloatingLinkPlugin }
